import { useEffect, useState } from "react";
import CountryService from "../../services/countryService";

const useJurisdictions = () => {
    const [jurisdictions, setJurisdictions] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const GetJurisdictions = () => {
            setLoading(true);
            CountryService
                .GetJurisdictions()
                .then( res => setJurisdictions(res) )
                .finally( setLoading(false) )
        }

        GetJurisdictions();
    }, [])

    return {
        loading,
        jurisdictions
    }
}

export default useJurisdictions;